import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Modal, Tooltip, Typography } from "@mui/material";
import cssClasses from "./FailedNbfcRecord.module.css";
import Close from "../../Icons/Close";

const dataGridStyles = {
  "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
    outline: "none",
  },
  border: "1px solid #EAECF0 !important",
  fontWeight: "400",
  fontSize: "1.4rem",
  lineHeight: "2rem",
  color: "#667085",
  fontFamily: "Inter-Medium",
  borderRadius: "8px",
  '& div[data-colindex="1"]': {
    color: "#101828",
    fontWeight: "500",
  },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      borderBottom: "1px solid #EAECF0",
      background: "#FFFFFF",
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: "1rem",

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    "& .MuiDataGrid-row.Mui-selected:hover": {
      borderBottom: "1px solid #EAECF0",
      backgroundColor: "#FFFFFF",
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  "& .MuiDataGrid-iconSeparator ": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeader:hover": {
    "& .MuiDataGrid-menuIcon": {
      visibility: "hidden",
    },
  },

  "&  .MuiDataGrid-columnHeaders": {
    background: "#F9FAFB",
    /* Gray/200 */
    border: "1px solid #EAECF0",
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: "1rem",
    borderBottom: "6px solid #EAECF0",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-checkboxInput": {
    "& svg": {
      width: "2rem",
      height: "2rem",
      background: "#FFFFFF",
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  "& .MuiDataGrid-footerContainer": {
    "& .MuiTablePagination-displayedRows ": {
      display: "none",
    },
    "& .MuiDataGrid-selectedRowCount": {
      visibility: "hidden ",
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: "none",
    cursor: "none",
  },
  "& [title='Go to previous page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to next page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: "1rem",
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: "1rem",
  },
  "& .MuiDataGrid-columnHeader": {
    // padding: "0 4rem",

    "&:focus": {
      outline: "none",
    },
  },
  "&  .MuiDataGrid-row ": {
    maxHeight: "72px !important",
    minHeight: "72px !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 4rem",
    minHeight: "72px !important",
    maxHeight: "72px !important",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiButtonBase-root": {
    fontSize: "1.6rem",
  },
  "& .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 1.5rem !important",
    fontFamily: "Roboto-Regular",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.4rem",
    lineHeight: "2rem",
    letterSpacing: "0.2px",
    color: "#3C4043",
    minHeight: "53px !important",
    outline: "none !important",
    cursor: "pointer",
    width: "100%",
    whiteSpace: "break-spaces !important",
  },
  "& .MuiDataGrid-row": {
    minHeight: "53px !important",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    padding: "1.5rem",
  },
  "& .MuiDataGrid-cellContent": {
    padding: "1.5rem",
    width: "100%",
    whiteSpace: "break-spaces !important",
    textOverflow: "unset !important",
  },
};

const FailedNbfcRecord = ({ open, handleClose, fieldEntriesArray }) => {
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={[
          {
            ".MuiBackdrop-root": {
              background: "rgba(193, 201, 210, 0.7)",
            },
          },
        ]}
        disableAutoFocus={true}
      >
        <Box className={cssClasses.modalWrapper}>
          <div className={cssClasses.header}>
            <h1>Failed Records</h1>
            <Box
              ml={"auto"}
              mt={1}
              onClick={handleClose}
              style={{ cursor: "pointer" }}
            >
              <Close width={"1.2rem"} height={"1.2rem"} />
            </Box>
          </div>

          <div
            className={cssClasses.mainContainer}
            style={{
              minHeight: "60rem",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <DataGrid
              rows={fieldEntriesArray}
              columns={failedEntriesColumns}
              hideFooterPagination={false}
              hideFooter={false}
              pageSize={10}
              rowsPerPageOptions={[10]}
              sx={[dataGridStyles]}
              disableColumnFilter
              disableColumnMenu
              disableColumnSelector
              disableDensitySelector
              disableSelectionOnClick
              disableVirtualization
            />
          </div>
        </Box>
      </Modal>
    </>
  );
};

const failedEntriesColumns = [
  {
    field: "NBFC Name",
    headerName: "NBFC Name",
    width: 150,
    sortable: false,
    renderCell: (params) => {
      return (
        <Box display={"flex"} flexDirection={"column"}>
          <Typography
            color={"#101828"}
            fontSize={"1.4rem"}
            lineHeight={"2rem"}
            fontWeight={500}
          >
            {params.row.nbfcName}
          </Typography>
        </Box>
      );
    },
  },
  {
    field: "reason",
    headerName: "Reason",
    width: 300,
    sortable: false,
    renderCell: (params) => {
      return (
        <>
            <Typography fontSize={"1.4rem"}>{params.row?.message}</Typography>
        </>
      );
    },
  },
];

export default FailedNbfcRecord;
